import { recordReleaseRoute } from './recordRoutes';

const encode = (value) => encodeURIComponent(String(value || '').trim());

export function searchResultRoute(item = {}) {
  if (item.canonical_path && String(item.canonical_path).startsWith('/')) {
    return String(item.canonical_path);
  }

  const sourceId = item.source_id || item.id;
  const sourceSlug = item.source_slug || item.slug || sourceId;
  const id = encode(sourceId);
  const slug = encode(sourceSlug);
  const type = String(item.type || '').toLowerCase();

  switch (type) {
    case 'event': return `/events/${id}`;
    case 'article': return `/news/${id}`;
    case 'product': return `/shop/${slug}`;
    case 'mixtape': return `/mixtapes/${id}`;
    case 'playlist': return `/playlists/${id}`;
    case 'video': return `/video-mixes/${id}`;
    case 'album':
    case 'track': return recordReleaseRoute(sourceId);
    case 'artist':
    case 'dj':
    case 'creator': return `/creator/${slug}`;
    case 'radio_show': return '/radio';
    default: return `/content/${encode(item.id)}`;
  }
}

export default searchResultRoute;
